<svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.10533 13.5893L0 7.48533L0.950666 6.53333L6.10533 11.688L17.7933 0L18.744 0.952L6.10533 13.5893ZM1.372 18.6667V17.3333H17.372V18.6667H1.372Z" fill="currentColor"/>
</svg>
